/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Make bridge</h4>

<p>Make a bridge connecting two or more selected faces, or two or more selected edges at the borders of open surfaces with a new face. </p>
<p>The bridge normally consists of linear edges. For bridges between faces, Phi will attempt a freeform bridge if Shift is pressed when this button is clicked. </p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('566462717')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function BridgeTooltip() {
    return h('div', { innerHTML: body });
}
